var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cardsRight"},[_c('div',{staticClass:"cardsRight-item"},[_c('div',{staticClass:"cardsRight-item-tit"},[_vm._v(_vm._s(_vm.cardsTit))]),_c('div',{staticClass:"cardsRight-item-conter"},[_vm._t("cardsConter")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }